import { getUpcomingDeliveries } from '../../../../modules/MyDeliveries/selectors'

export const canCancelSubscriptionSelector = state => {
  const days = getUpcomingDeliveries(state)
  if (!days || days.length === 0) return { result: false, completed: false }
  const firstOrder = days.find(day => day.isFirstOrder)
  return { result: !firstOrder, completed: true }
}
